import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { getChatRoomListsV2 } from "../../api/chats";
import {
    fetchChatContactsRequest,
    fetchChatContactsSuccess,
    fetchChatContactsFailure
} from "./slice";

import { changeSelectedChat } from "../../redux/actions";
import { UserTypes } from "api";

function* handlefetchChatContacts(action: ReturnType<typeof fetchChatContactsRequest>) {
    try {
        const {
            page, filter, isFetchNext,
            filterUnread, filterPersonUnRead, filterNoActivity, filterSaleIds, filterCsIds, filterProvinceIds, groupType,
            currentSelectedChatId, companyType
        } = action.payload;
        const response: Promise<any> = yield call(getChatRoomListsV2, filter, page, groupType, filterUnread, filterPersonUnRead, filterNoActivity, filterSaleIds, filterCsIds, filterProvinceIds, companyType);
        // console.log(`getChatRoomListsV2 ${groupType}:`, response);
        const r2 = response as any;
        if (currentSelectedChatId && page == 1) { // first time seach
            // check if current selected found in new list or not, if not found then set current chat to null
            const foundCurrentChat = r2.chatContacts.find((ee: any) => ee.userId == currentSelectedChatId);
            if (!foundCurrentChat) { // not found active chat from result, then set it to null
                yield put(changeSelectedChat(null));
            }
        }
        yield put(fetchChatContactsSuccess({ chatContacts: r2.chatContacts, currentPage: r2.currentPage, nextPage: r2.currentPage + 1, hasMore: r2.hasMore, isFetchNext: isFetchNext, groupType: groupType }));
    } catch (error: any) {
        // console.log('getChatRoomListsV2 - err');
        console.error(error);
        yield put(fetchChatContactsFailure(error.message));
    }
}

export default function* chatRoomSaga() {
    //yield takeLatest(fetchChatContactsRequest.type, handlefetchChatContacts);
    yield takeEvery(fetchChatContactsRequest.type, handlefetchChatContacts);
}

